/*###########################################################################
// Brochure form
//#########################################################################*/

import axios from 'axios'
import { addElement } from '../utilities/_elements'
import { scrollTo } from "../utilities/_scrollTo"

window.brochureForm = {
	handleFormSubmit(e) {
		const form = e.target
		const formSuccess = form.closest('.form-container').querySelector('.form-success')

		const interestedEl = form.querySelector('[data-formie-field-type="radio"] input[value="Yes"]:checked')
		let interested = 'No'
		if (interestedEl !== null) {
			interested = 'Yes'
		}

		const brandCheckboxes = form.querySelectorAll('[data-formie-field-type="entries"] .checkbox input:checked')
		let brandIds = ''
		const brandNames = []

		for (let i = 0; i < brandCheckboxes.length; i++) {
			const brandCheckbox = brandCheckboxes[i]
			const checkboxContainer = brandCheckbox.closest('.checkbox')
			const nestedLabel = checkboxContainer !== null ? checkboxContainer.querySelector('label') : null
			const linkedLabel = brandCheckbox.id !== '' ? form.querySelector('label[for="' + brandCheckbox.id + '"]') : null
			const brandName = (nestedLabel !== null ? nestedLabel.textContent : linkedLabel !== null ? linkedLabel.textContent : '').trim()

			if (brandIds === '') {
				brandIds = brandCheckbox.value
			} else {
				brandIds = brandIds + ', ' + brandCheckbox.value
			}

			if (brandName !== '') {
				brandNames.push(brandName)
			}
		}

		axios.get('/get-brochures?interested=' + interested + '&brandIds=' + brandIds)
			.then(function (response) {
				if (formSuccess !== null) {
					if (typeof window.gtag === 'function') {
						if (interested === 'Yes') {
							for (let i = 0; i < brandNames.length; i++) {
								window.gtag('event', 'brochure_download', {
									requested_brochure: brandNames[i]
								})
							}
						} else {
							window.gtag('event', 'brochure_download', {
								requested_brochure: 'No Brand Interest'
							})
						}
					}

					addElement({
						elementTag: 'div',
						classes: '',
						innerHTML: response.data,
						appendTo: formSuccess,
						after: (newEl, parentElement, self) => {
							const offsetAmount = document.querySelector('.header').clientHeight + 40
							scrollTo(formSuccess.closest('section'), -offsetAmount)
						}
					})
				}
			})
	}
}
